module.exports = __webpack_public_path__ + "static/media/m-tech.7ac4951b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/m-tech.jpg
// module id = 30
// module chunks = 0